import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { DoiTraHang } from '../kd-doi-tra-hang-model/kd-doi-tra-hang.model';
import { KhachHangModelLite } from '../../../dung-chung/__model/common_config.model';

const API_ROOT_URL = environment.ApiRoot + '/kinhdoanh';

@Injectable()
export class DoiTraHangService {
	
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DTH_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataHHKH(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/HangHoa_List_BanKH', { 
			headers: httpHeaders,
			params: httpParams	
		});
	}
	getDataHCBG(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/HangChoBaoGia_List', { 
			headers: httpHeaders,
			params: httpParams	
		});
	}
	getDataLSG(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/History_HangHoa_List_BanKH', { 
			headers: httpHeaders,
			params: httpParams	
		});
	}
	getDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DoiTraHang>(API_ROOT_URL+'/DTH_Get_Detail', item, { headers: httpHeaders });
	}
	getDataMaster(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DTH_Get_Master?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getDetailById(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DTH_Get_Detail_Id?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */


	/*-------------------------------POST Method---------------------------- */
	add(item: DoiTraHang): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DoiTraHang>(API_ROOT_URL+'/DTH_Insert', item, { headers: httpHeaders });
	}
	updatWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DoiTraHang>(API_ROOT_URL+'/DTH_Update_With_Detail', item, { headers: httpHeaders });
	};
	DoiTraHang_Confirm(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DoiTraHang>(API_ROOT_URL+'/DoiTraHang_Confirm', item, { headers: httpHeaders });
	}
	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DTH_Delete?id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DTH_Cancel?id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	setKH(data: KhachHangModelLite): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  API_ROOT_URL + '/InsertCustomer' ;
		return this.http.post<any>(url , data ,{ headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */
}
